if (!window.__cartNewLineAddInitialized) {
  window.__cartNewLineAddInitialized = true;

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productFormComponent = form.closest('product-form-component');
      if (!productFormComponent) return;

      if (productFormComponent.dataset.newLineAdd !== 'true') return;

      form
        .querySelectorAll('input[name="properties[_product_group_id]"]')
        .forEach((el) => el.remove());

      const groupInput = document.createElement('input');
      groupInput.type = 'hidden';
      groupInput.name = 'properties[_product_group_id]';
      groupInput.value = Date.now().toString(36) + Math.random().toString(36).slice(2);
      form.appendChild(groupInput);

      if (!form.querySelector('input[name="properties[_is_upsell]"]')) {
        const upsellInput = document.createElement('input');
        upsellInput.type = 'hidden';
        upsellInput.name = 'properties[_is_upsell]';
        upsellInput.value = 'false';
        form.appendChild(upsellInput);
      }
    },
    true
  );
}
